const state = {
    centros_costos: [],
    tipos_documento: [],
}

const actions = {
    _setCentrosCostos(store, centros_costos) {
        store.commit("setCentrosCostos", centros_costos)
    },
    _setTiposDocumento(store, tipos_documento) {
        store.commit("setTiposDocumento", tipos_documento)
    },
}

const mutations = {
    setCentrosCostos(state, centros_costos) {
        state.centros_costos = centros_costos
    },
    setTiposDocumento(state, tipos_documento) {
        state.tipos_documento = tipos_documento
    },
}

const getters = {
    _centros_costos: state => state.centros_costos,
    _tipos_documento: state => state.tipos_documento,
}

export const CajaStore = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
